.cards {
  padding: 72px 0 56px;
}

.cards__grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
}

/* Block wrapper so the CTA stays content-width + left-aligned (the card is a stretch flex column;
   a bare button as a direct child would stretch to full width). */
.card__cta {
  margin-top: 6px;
}

.card {
  position: relative;
  background: var(--color-primary-grey-000); /* PRIMARY_GREY_000 */
  border: var(--plume-border-card, 2px solid var(--color-primary-grey-900));
  border-radius: 18px;
  padding: 32px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  box-shadow: var(--plume-shadow-card, 1px 2px 10px 0 rgba(89, 84, 78, 0.12));
  transition:
    transform 0.22s ease,
    box-shadow 0.22s ease;
  overflow: hidden;
}

.card:hover {
  box-shadow: var(--plume-shadow-card-hover, 1px 2px 32px 0 rgba(89, 84, 78, 0.12));
  transform: var(--plume-hover-shift, translateY(-3px));
}

/* Hover shadow follows the card's icon color — only under the contrast (sticker) theme, matching
   the mockup's `:root[data-depth="sticker"] .card--hover-*:hover` scoping. Under soft, cards keep
   the theme's blurred hover shadow. */
:global(:root[data-theme='contrast']) .cardHoverBlue:hover {
  box-shadow: 10px 10px 0 var(--color-primary-blue-500); /* PRIMARY_BLUE_500 */
}

:global(:root[data-theme='contrast']) .cardHoverRed:hover {
  box-shadow: 10px 10px 0 var(--color-primary-red-500); /* PRIMARY_RED_500 */
}

.card__icon {
  width: 56px;
  height: 56px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.card__icon svg {
  width: 26px;
  height: 26px;
}

.cardIconBlue {
  background: var(--color-primary-blue-500); /* PRIMARY_BLUE_500 */
  color: var(--color-primary-grey-000);
}

.cardIconYellow {
  background: var(--color-complementary-yellow); /* COMPLEMENTARY_YELLOW */
  color: var(--color-primary-grey-900);
}

.cardIconRed {
  background: var(--color-primary-red-500); /* PRIMARY_RED_500 */
  color: var(--color-primary-grey-000);
}

.card__title {
  font-family: var(--plume-font-display, sofia-pro, sans-serif);
  font-weight: 900;
  font-size: 26px; /* HEADING_M */
  line-height: 1.1;
  color: var(--color-primary-grey-900); /* PRIMARY_GREY_900 */
  margin: 0;
}

.card__body {
  font-size: 16px; /* COPY_M */
  line-height: 1.5; /* COPY_M */
  color: var(--color-primary-sand-900); /* PRIMARY_SAND_900 */
  flex: 1;
  margin: 0;
}

.card__body a {
  color: var(--color-primary-blue-700); /* PRIMARY_BLUE_700 */
  font-weight: 700;
  text-decoration: underline;
  text-underline-offset: 2px;
}

.cardYellow {
  /* yellow accent sticker shadow, resting and on hover */
  box-shadow: var(--plume-shadow-darkcard, 1px 2px 14px 0 rgba(89, 84, 78, 0.12));
}

.cardYellow:hover {
  box-shadow: var(--plume-shadow-darkcard-hover, 1px 2px 32px 0 rgba(89, 84, 78, 0.12));
}

@media (max-width: 860px) {
  .cards__grid {
    grid-template-columns: 1fr;
  }
}
